import React from "react";
import PropTypes from "prop-types";

const TextInput = ({ name, label, onChange, onKeyPress, onKeyDown, onKeyUp, onFocus, onBlur, placeholder, value, error, maxlength, disabled, tabIndex, autoFocus, className, inputClassName, isPassword, id, autoComplete = false }) => {
    let wrapperClass = "form-group";
    if (error && error.length > 0) {
        wrapperClass += " " + "has-error";
    }
    if (className)
        wrapperClass += " " + className;

    const inputProps = {};
    inputProps["disabled"] = disabled;
    inputProps["autoFocus"] = autoFocus;
    let inputId = name + "Input";

    if (id) {
        inputId = id;
    }

    if (autoComplete) {
        inputProps["autoComplete"] = "on";
    }

    const inputType = isPassword ? "password" : "text";
    const inputFinalClassName = inputClassName ? inputClassName: "form-control";
    return (
        <div className={wrapperClass}>
            {label && <label htmlFor={name}>{label}</label>}
            <input
                id={inputId}
                type={inputType}
                name={name}
                tabIndex={tabIndex}
                className={inputFinalClassName}
                placeholder={placeholder}
                maxLength={maxlength}
                value={value}
                {...inputProps}
                onChange={onChange}
                onKeyPress={onKeyPress}
                onKeyDown={onKeyDown}
                onKeyUp={onKeyUp}
                onFocus={onFocus}
                onBlur={onBlur}
                size=""
            />
            {error && <div className="validate-error-message">{error}</div>}
        </div>
    );
};

TextInput.propTypes = {
    name: PropTypes.string,
    label: PropTypes.string,
    onChange: PropTypes.func,
    onKeyPress: PropTypes.func,
    onKeyDown: PropTypes.func,
    onKeyUp: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    placeholder: PropTypes.string,
    maxlength: PropTypes.number,
    value: PropTypes.string,
    error: PropTypes.string,
    disabled: PropTypes.bool,
    tabIndex: PropTypes.string,
    autoFocus: PropTypes.bool,
    className: PropTypes.string,
    inputClassName: PropTypes.string,
    isPassword: PropTypes.bool,
    autoComplete: PropTypes.bool
};

export default TextInput;
